// Configuração das marcas do grupo TNS
export const BRAND_CONFIG = {
  'thenews': {
    newName: 'the news',
    oldName: 'the news',
    colorFrom: '#FF8D4F',
    colorTo: '#FFD800',
    hasFullCategories: true,
  },
  'thenews-business': {
    newName: 'the news business',
    oldName: 'the bizness',
    colorFrom: '#4341B4',
    colorTo: '#F252A0',
    hasFullCategories: false,
  },
  'thenews-travel': {
    newName: 'the news travel',
    oldName: 'the travel',
    colorFrom: '#231F20',
    colorTo: '#D1D3D4',
    hasFullCategories: false,
  },
  'thenews-cult': {
    newName: 'the news cult',
    oldName: 'the stories',
    colorFrom: '#E95D6C',
    colorTo: '#F6B6BF',
    hasFullCategories: false,
  },
  'thenews-health': {
    newName: 'the news health',
    oldName: 'Health Times',
    colorFrom: '#78A2F7',
    colorTo: '#C1E9F6',
    hasFullCategories: false,
  },
  'thenews-money': {
    newName: 'the news money',
    oldName: 'THE PAPER',
    colorFrom: '#00A89C',
    colorTo: '#A1D97A',
    hasFullCategories: false,
  },
  'thenews-sports': {
    newName: 'the news sports',
    oldName: 'the champs',
    colorFrom: '#C41E20',
    colorTo: '#ED2F35',
    hasFullCategories: false,
  },
  'thenews-trends': {
    newName: 'the news trends',
    oldName: 'Trend Report',
    colorFrom: '#FF2E23',
    colorTo: '#FF955A',
    hasFullCategories: false,
  },
  'thenews-around': {
    newName: 'the news around',
    oldName: 'GoGet',
    colorFrom: '#4D5030',
    colorTo: '#D1CDC0',
    hasFullCategories: false,
  },
} as const;

export type BrandKey = keyof typeof BRAND_CONFIG;
export type BrandConfig = typeof BRAND_CONFIG[BrandKey];

// Mapeamento de chaves legadas (URL params antigos) para as novas marcas
export const LEGACY_NEWSLETTER_MAP: Record<string, BrandKey> = {
  'thenews': 'thenews',
  'thebizness': 'thenews-business',
  'thestories': 'thenews-cult',
  'healthtimes': 'thenews-health',
  'thechamps': 'thenews-sports',
  'goget': 'thenews-around',
};

// Categorias principais e suas subcategorias
export const SUPPORT_CATEGORIES = {
  "Programa de indicação e prêmios": [
    "Não estou conseguindo indicar o the news",
    "Meu prêmio chegou com defeito",
    "Não recebi meus prêmios",
    "Giveaway"
  ],
  "Streak (pontuação diária)": [
    "Meus pontos no streak não estão sendo contabilizados"
  ],
  "Problemas de recebimento das edições e cadastro": [
    "Me desinscrevi e continuo recebendo",
    "Não estou recebendo a edição",
    "Alteração de cadastro"
  ],
  "Portal de notícias do the news": [
    "O portal não abre",
    "O portal está travando",
    "Problemas ao carregar conteúdo no portal",
    "Outros"
  ],
  "Feedback e Erros": [],
  "Outros": [],
  "Quiz": []
} as const;

// Gradiente padrão do suporte TNS
export const TNS_GRADIENT = {
  from: '#ffce04',
  to: '#ff8a47',
} as const;
